import { render, staticRenderFns } from "./InvoiceDisbursementDetailsDrawer.vue?vue&type=template&id=9bccd5c2&scoped=true"
import script from "./InvoiceDisbursementDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./InvoiceDisbursementDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDisbursementDetailsDrawer.vue?vue&type=style&index=0&id=9bccd5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bccd5c2",
  null
  
)

export default component.exports